<div class="footer" rte="13U">
    <p-menubar *ngIf="ultimaMain.isDesktop" [model]="app.footerMenuModel" rte="13V">
        <div class="copyright" rte="13W">
            <i *ngIf="app.systemDataInfoAvailable" class="material-icons info-icon" (click)="app.showSystemDataInfoDialog()" rte="13X">
                info
            </i>
            <b rte="13Y">BB</b>&nbsp;Web Template {{ app.versionInfo?.pipeline }}
        </div>
    </p-menubar>

    <div *ngIf="!ultimaMain.isDesktop" class="tablet-footer-container" rte="13Z">
        <i class="pi pi-bars footer-menu-trigger" (click)="footerMobileMenu.toggle($event)" rte="140"></i>
        <p-menu #footerMobileMenu appendTo="body" [model]="app.footerMenuModel" [popup]="true" [baseZIndex]="10100" rte="141"> </p-menu>

        <div class="copyright" rte="142">
            <i *ngIf="app.systemDataInfoAvailable" class="material-icons info-icon" (click)="app.showSystemDataInfoDialog()" rte="143"
                >info</i
            ><b rte="144">BB</b>&nbsp;Web Template {{ app.versionInfo?.pipeline }}
        </div>
    </div>
</div>
